
export const VIEWPORT_RESIZE = 'VIEWPORT_RESIZE';
export function handleViewportResize(newSize) {
    return (dispatch, getState) => {
        return dispatch({
            type: VIEWPORT_RESIZE,
            size: newSize
        })
    }
}

export const DEMO_FILTER = 'DEMO_FILTER';
export function filterDemoList(keyword) {
    return (dispatch, getState) => {
        return dispatch({
            type: DEMO_FILTER,
            keyword: keyword
        })
    }
}

export const NAVI_TREE_TOGGLE = "NAVI_TREE_TOGGLE";
export function toggleNaviTree(key) {
    return (dispatch, getState) => {
        return dispatch({
            type: NAVI_TREE_TOGGLE,
            key: key
        })
    }
}

export const NAVI_TREE_EXPAND = "NAVI_TREE_EXPAND";
export function expandNaviTree(key) {
    return (dispatch, getState) => {
        return dispatch({
            type: NAVI_TREE_EXPAND,
            key: key
        })
    }
}

export const CHANGE_USER_LANG = "CHANGE_USER_LANG";
export function updateUserLang(lang) {
    return (dispatch, getState) => {
        return dispatch({
            type: CHANGE_USER_LANG,
            lang: lang
        })
    }
}



// WEBPACK FOOTER //
// ./client/actions/index.js